import { type ChatbotParams } from "@do/shared-types";

export const CSSVariables = ({
  chatbotParams,
}: {
  chatbotParams: Pick<ChatbotParams, "theme">;
}) => {
  return (
    chatbotParams.theme && (
      <style>
        {`:root {
  ${Object.entries(chatbotParams.theme)
    .map(([key, value]) => {
      const cssVarName = key.startsWith("--") ? key : `--${key}`;
      return `${cssVarName}: ${value};`;
    })
    .join("\n")}
}`}
      </style>
    )
  );
};
